<div class="flex-column gap-32">

	<app-card preCardTitle="Group Management">
		<div *appCardContent class="settings-header-container">
			<div class="settings-header-title">
				<p>Add Observation Group</p>
				<div class="settings-header-subtitle">Observation groups can be assigned to your vehicle groups</div>
			</div>
			<div class="settings-header-actions">
				<button (click)="addObservationTypeGroupDialog()"
						mat-stroked-button>
					Add Observation Group
				</button>
			</div>
		</div>
	</app-card>

	@if (isLoading) {
		<mat-spinner class="mx-a mt-15" diameter="30"></mat-spinner>
	} @else {
		<app-card preCardTitle="Observation Groups">
			<div *appCardContentRaw>
				<mat-nav-list class="raw-card-list">
					<mat-menu #menuGroup="matMenu">
						<ng-template matMenuContent let-group="group">
							<button mat-menu-item
									[routerLink]="['/' + RootRoute.SETTINGS, SettingsRoute.MANAGE_OBSERVATIONS, 'group', group.id]">
								Open
							</button>
							<button mat-menu-item (click)="changeGroupName(group)">
								Rename
							</button>
							<button mat-menu-item (click)="assignVehiclesToGroup(group)">
								Assign
							</button>
							<button mat-menu-item (click)="removeGroup(group)">
								Remove
							</button>
						</ng-template>
					</mat-menu>
					@for (group of observationTypeGroups; track group.id) {
						<mat-list-item
								[routerLink]="['/', RootRoute.SETTINGS, SettingsRoute.MANAGE_OBSERVATIONS, 'group', group.id]">
							<a matListItemTitle>{{ group.name }}</a>
							<div matListItemMeta>
								<button mat-icon-button
										(click)="$event.stopPropagation()"
										[matMenuTriggerFor]="menuGroup"
										[matMenuTriggerData]="{group:group}"
										aria-label="Menu">
									<mat-icon>more_vert</mat-icon>
								</button>
							</div>
						</mat-list-item>
						@if (!$last) {
							<mat-divider></mat-divider>
						}
					}
				</mat-nav-list>
			</div>
		</app-card>
	}
</div>
